<template>
  <div style="height: 100%">
    <StructureCompanyAddAndLinkWorkRoleModal ref="addAndlinkWorkRoleModal" />
    <EmployeeRolesLinkModal ref="employeeRolesLink" :showBtn="false" />
    <DeleteModal ref="deleteModal" :showBtn="false" />
    <div class="tree" id="tree" ref="tree"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import OrgChart from '@balkangraph/orgchart.js'
import StructureCompanyAddAndLinkWorkRoleModal from 'components/setting/structureCompany/StructureCompanyAddAndLinkWorkRoleModal'
import EmployeeRolesLinkModal from 'components/employees/EmployeeRolesLinkModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'StructureCompanyTree',
  components: {
    StructureCompanyAddAndLinkWorkRoleModal,
    EmployeeRolesLinkModal,
    DeleteModal,
  },
  props: ['roles'],
  data() {
    return {}
  },

  computed: {
    ...mapGetters(['apiDomain']),
    rolesFormatteds() {
      return this.rolesFormatted()
    },
    refsTree() {
      return this.$refs.tree
    },
  },

  watch: {
    roles: {
      deep: true,
      handler() {
        this.oc(this.$refs.tree, this.rolesFormatted(), this.$refs, this)
      },
    },
  },
  mounted() {
    console.log('OrgChart.templates.ana', OrgChart)
    OrgChart.templates.ana.menuButton =
      //     '<div style="display:grid;align-items:center;position:absolute;right:30px;top:30px;width:40px;height:35px;cursor:pointer;" data-ctrl-menu=""><hr style="background-color: #7A7A7A; height: 3px; border: none;"><hr style="background-color: #7A7A7A; height: 3px; border: none;"><hr style="background-color: #7A7A7A; height: 3px; border: none;"></div>'
      '<div style="display:grid;align-items:center;position:absolute;right:{p}px;top:{p}px; width:35px;height:35px;cursor:pointer;background:#ffffff; padding: 0 2.5px;border-radius:4px" data-ctrl-menu=""><hr style="background-color: #7A7A7A; height: 3px; border: none;"><hr style="background-color: #7A7A7A; height: 3px; border: none;"><hr style="background-color: #7A7A7A; height: 3px; border: none;"></div>'
    OrgChart.SEARCH_PLACEHOLDER = this.localStorage.translations.pages.common.text['search']
    let menuIcon =
      '<g style="cursor:pointer;" transform="matrix(1,0,0,1,{ew},10)" data-ctrl-n-menu-id="{id}">' +
      '<rect x="-10" y="-10" fill="#000000" fill-opacity="0" width="30" height="30"></rect>' +
      '<circle cx="5.5" cy="0" r="2" fill="#F2F2F2"/>' +
      '<circle cx="5.5" cy="5" r="2" fill="#F2F2F2"/>' +
      '<circle cx="5.5" cy="10" r="2" fill="#F2F2F2"/>' +
      '</g>'
    let linkStyle =
      '<path stroke-linejoin="round" stroke="#aeaeae" stroke-width="1px" fill="none" d="{edge}" />'

    OrgChart.templates.vacantion = Object.assign({}, OrgChart.templates.ana)

    OrgChart.templates.vacantion.size = [254, 91]
    OrgChart.templates.vacantion.node =
      '<rect x="0" y="0" height="{h}" width="{w}" fill="#6AB1D8" stroke-width="1" stroke="#aeaeae" rx="10" ry="10"></rect>'

    OrgChart.templates.vacantion.nodeMenuButton = menuIcon
    OrgChart.templates.vacantion.img_0 =
      '<clipPath id="ulaImg">' +
      '<circle cx="38" cy="16" r="29"></circle>' +
      '</clipPath>' +
      '<image preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="10" y="-13" width="58" height="58">' +
      '</image>'
    OrgChart.templates.vacantion.field_0 =
      '<text width="224" style="font-size: 18px; font-weight: 500;" fill="#ffffff" x="127" y="75" text-anchor="middle">{val}</text>'
    OrgChart.templates.vacantion.field_1 =
      '<text width="155" text-overflow="multiline" style="font-size: 14px; font-weight: 500;" fill="#ffffff" x="225" y="20" text-anchor="end">{val}</text>'

    OrgChart.templates.role = Object.assign({}, OrgChart.templates.group)
    OrgChart.templates.role.link = linkStyle
    OrgChart.templates.role.field_0 =
      '<text width="230" style="font-size: 18px; font-weight: 500;" fill="#ffffff" x="{cw}" y="30" text-anchor="middle">{val}</text>'
    OrgChart.templates.role.node =
      '<rect rx="10" ry="10" x="0" y="0" height="{h}" width="{w}" fill="#277faf" stroke-width="0"></rect>'
    OrgChart.templates.role.nodeMenuButton = menuIcon

    OrgChart.templates.role.min = Object.assign({}, OrgChart.templates.role)
    OrgChart.templates.role.min.size = [254, 60]
    OrgChart.templates.role.min.field_0 =
      '<text width="230" style="font-size: 18px; font-weight: 500;" fill="#ffffff" x="{cw}" y="34" text-anchor="middle">{val}</text>'

    OrgChart.templates.group.link = linkStyle
    OrgChart.templates.group.node =
      '<rect rx="10" ry="10" x="0" y="0" height="{h}" width="{w}" fill="#f2f2f2" stroke-width="0"></rect>'
    OrgChart.templates.group.field_0 =
      '<text width="230" style="font-size: 18px; font-weight: 500;" fill="#277FAF" x="{cw}" y="30" text-anchor="middle">{val}</text>'
    OrgChart.templates.group.nodeMenuButton =
      // '<g style="cursor:pointer;" transform="matrix(1,0,0,1,{ew},10)" data-ctrl-n-menu-id="{id}">' +
      // '<path d="M0 5.14286H12V6.85714H0V5.14286Z" fill="#277FAF"/>' +
      // '<path d="M6.85714 7.49335e-08L6.85714 12H5.14286L5.14286 0L6.85714 7.49335e-08Z" fill="#277FAF"/>' +
      // '</g>'
      '<g style="cursor:pointer;" transform="matrix(1,0,0,1,{ew},10)" data-ctrl-n-menu-id="{id}">' +
      '<rect x="-10" y="-10" fill="#000000" fill-opacity="0" width="30" height="30"></rect>' +
      '<circle cx="5.5" cy="0" r="2" fill="#277FAF"/>' +
      '<circle cx="5.5" cy="5" r="2" fill="#277FAF"/>' +
      '<circle cx="5.5" cy="10" r="2" fill="#277FAF"/>' +
      '</g>'
    this.oc(this.$refs.tree, this.rolesFormatted(), this.$refs, this)
  },

  methods: {
    ...mapActions('employeeRoles', ['onEmployeeRolesGrid', 'onEmployeeRolesDelete']),
    rolesFormatted() {
      let array = []
      if (this.roles.length) {
        for (let item = 0; item < this.roles.length; item++) {
          let itemObg = {}
          itemObg.tags = []
          itemObg.id = this.roles[item].id
          itemObg.name = this.roles[item].name
          itemObg.type = this.roles[item].type
          if (this.roles[item].type) {
            itemObg.tags.push(this.roles[item].type)
            if (this.roles[item].type == 'role') {
              if (this.roles[item].vacancies_count > 0 || this.roles[item].users.length) {
                itemObg.tags.push('role_with_vacancies')
              } else {
                itemObg.tags.push('role_min')
              }
              if (this.roles[item].vacancies_count > this.roles[item].users_count) {
                itemObg.tags.push('vacancies_active')
              }
              if (this.roles[item].parent_id) {
                itemObg.tags.push('parent_on')
              }
            }
          }
          // if (this.roles[item].users.length) {
          //     itemObg.tags.push('group')
          // }
          if (this.roles[item].parent_id) {
            if (this.roles.find((i) => i.id === this.roles[item].parent_id).type == 'role') {
              itemObg.pid = this.roles[item].parent_id
            } else {
              itemObg.stpid = this.roles[item].parent_id
            }
          }
          array.push(itemObg)
          if (this.roles[item].users.length) {
            let users = this.roles[item].users
            for (let user = 0; user < this.roles[item].users.length; user++) {
              let userObg = {}
              userObg.tags = []
              userObg.id = users[user].id
              userObg.stpid = this.roles[item].id
              userObg.name = users[user].first_name + ' ' + users[user].last_name
              userObg.title = this.roles[item].name
              userObg.type = 'user'
              if (users[user].photo) {
                userObg.img = this.apiDomain + '/min/' + users[user].photo
              } else {
                userObg.img = require('~/assets/svg/user_structure_company.svg')
              }
              userObg.tags.push('user')

              array.push(userObg)
            }
          }
          if (this.roles[item].vacancies_count > this.roles[item].users_count) {
            for (
              let vacantion = 0;
              vacantion < this.roles[item].vacancies_count - this.roles[item].users_count;
              vacantion++
            ) {
              let vacantionObg = {}
              vacantionObg.tags = []
              vacantionObg.id = this.roles[item].id + '_' + vacantion
              vacantionObg.stpid = this.roles[item].id
              vacantionObg.name = this.localStorage.translations.pages.common.text['vacantion']
              vacantionObg.title = this.roles[item].name
              vacantionObg.type = 'user'
              vacantionObg.img = require('~/assets/svg/user_structure_company.svg')
              vacantionObg.tags.push('vacantion')

              array.push(vacantionObg)
            }
          }
        }
      }
      return array
    },
    onDeleteRoleOrGroup(id) {
      this.$refs.deleteModal.openModal()
      this.$refs.deleteModal.id = id

      this.$refs.deleteModal.textShow =
        this.roles.find((i) => i.id === id).type === 'role'
          ? this.localStorage.translations.pages['setting-structure_company'].buttons.delete_role +
            ' ' +
            this.roles.find((i) => i.id === id).name
          : this.localStorage.translations.pages['setting-structure_company'].buttons.delete_group +
            ' ' +
            this.roles.find((i) => i.id === id).name
      this.$refs.deleteModal.textBtn =
        this.localStorage.translations.pages.common.buttons['primenit']
      this.$refs.deleteModal.methodDeleteShow = function () {
        this.$store
          .dispatch('employeeRoles/onEmployeeRolesDelete', id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('employeeRoles/onEmployeeRolesGrid', {
              limit: 100000,
              page: 1,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
            this.closeModal()
          })
      }
    },

    onUnlinkRoleOrGroup(id) {
      let findObject = this.roles.find((i) => i.id === id)
      this.$refs.deleteModal.openModal()
      this.$refs.deleteModal.id = id
      this.$refs.deleteModal.textShow =
        findObject.type === 'role'
          ? this.localStorage.translations.pages['setting-structure_company'].buttons.unlink_role +
            ' ' +
            findObject.name
          : this.localStorage.translations.pages['setting-structure_company'].buttons.unlink_group +
            ' ' +
            findObject.name
      this.$refs.deleteModal.textBtn =
        this.localStorage.translations.pages.common.buttons['primenit']
      let data = {
        id: id,
        name: findObject.name,
        type: findObject.type,
        parent_id: null,
      }
      this.$refs.deleteModal.methodDeleteShow = function () {
        this.$store
          .dispatch('employeeRoles/onEmployeeRolesUpdate', data)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'izmeneniya-uspeshno-sohraneny'
                  ],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('employeeRoles/onEmployeeRolesGrid', {
              limit: 100000,
              page: 1,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
            this.closeModal()
          })
      }
    },
    onUnlinkEmployeeRole(id) {
      let findEmployee = this.rolesFormatteds.find((i) => i.id === id)
      this.$refs.deleteModal.openModal()
      this.$refs.deleteModal.id = id
      this.$refs.deleteModal.textShow =
        this.localStorage.translations.pages['setting-structure_company'].buttons
          .employee_role_unlink +
        ' ' +
        findEmployee.name
      this.$refs.deleteModal.textBtn =
        this.localStorage.translations.pages.common.buttons['primenit']
      let data = {
        user_id: id,
        work_role_id: null,
      }
      this.$refs.deleteModal.methodDeleteShow = function () {
        this.$store
          .dispatch('user/onUserUpdateWorkRole', data)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'izmeneniya-uspeshno-sohraneny'
                  ],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('employeeRoles/onEmployeeRolesGrid', {
              limit: 100000,
              page: 1,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
            this.closeModal()
          })
      }
    },
    onVacantionDelete(id) {
      let findVacantion = this.rolesFormatteds.find((i) => i.id === id)
      this.$refs.deleteModal.openModal()
      this.$refs.deleteModal.id = id
      this.$refs.deleteModal.textShow =
        this.localStorage.translations.pages['setting-structure_company'].buttons.delete_vacantion +
        ' ' +
        findVacantion.title
      let data = {
        id: findVacantion.stpid,
        change: -1,
      }
      this.$refs.deleteModal.methodDeleteShow = function () {
        this.$store
          .dispatch('employeeRoles/onEmployeeRolesDeleteOneVacantion', data)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'izmeneniya-uspeshno-sohraneny'
                  ],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('employeeRoles/onEmployeeRolesGrid', {
              limit: 100000,
              page: 1,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
            this.closeModal()
          })
      }
    },

    oc: function (domEl, x, refs, thiss) {
      // OrgChart.templates.cool.name = '<text  style="font-size: 18px;" fill="#afafaf" x="110" y="30">{val}</text>';
      let chart = new OrgChart(domEl, {
        nodes: x,
        template: 'ana',
        mouseScrool: false,
        enableDragDrop: false,
        layout: OrgChart.treeRightOffset,
        nodeMouseClick: null,
        orientation: OrgChart.orientation.top_left,
        nodeMenu: {},
        searchFields: ['name'],
        searchDisplayField: 'name',
        menu: {
          pdfPreview: {
            text: this.localStorage.translations.pages.common.buttons['sohranit'] + ' PDF',
            icon: OrgChart.icon.pdf(24, 24, '#7A7A7A'),
            onClick: exportPDF,
          },
        },
        toolbar: {
          fullScreen: true,
          zoom: true,
          fit: true,
        },
        nodeBinding: {
          field_0: 'name',
          field_1: 'title',
          img_0: 'img',
        },
        tags: {
          role: {
            template: 'role',
            subTreeConfig: {
              columns: 2,
            },
          },
          role_min: {
            template: 'role',
            min: true,
          },
          group: {
            template: 'group',
            nodeMenu: {
              editGroup: {
                text: this.localStorage.translations.pages.common.buttons['redaktirovat'],
                icon: editIcon,
                onClick: this.$refs.addAndlinkWorkRoleModal.openModalEditGroup,
              },
              addRole: {
                text: this.localStorage.translations.pages['setting-structure_company'].buttons
                  .create_role,
                icon: createRoleIcon,
                onClick: this.$refs.addAndlinkWorkRoleModal.openModalAddRole,
              },
              linkRole: {
                text: this.localStorage.translations.pages['setting-structure_company'].buttons
                  .link_role,
                icon: linkRoleIcon,
                onClick: this.$refs.addAndlinkWorkRoleModal.openModalLinkRole,
              },
              unlinkGroup: {
                text: this.localStorage.translations.pages['setting-structure_company'].buttons
                  .unlink_group,
                icon: unlinkIcon,
                onClick: this.onUnlinkRoleOrGroup,
              },
              deleteGroup: {
                text: this.localStorage.translations.pages['setting-structure_company'].buttons
                  .delete_group,
                icon: deleteRoleGroupIcon,
                onClick: this.onDeleteRoleOrGroup,
              },
            },
          },

          user: {
            template: 'vacantion',
            nodeMenu: {
              newUserRoleLink: {
                text: this.localStorage.translations.pages['setting-structure_company'].buttons
                  .employee_role_relink,
                icon: employeLinkIcon,
                onClick: this.$refs.employeeRolesLink.openModalEdit_userId,
              },
              userRoleLink: {
                text: this.localStorage.translations.pages['setting-structure_company'].buttons
                  .employee_role_unlink,
                icon: unlinkIcon,
                onClick: this.onUnlinkEmployeeRole,
              },
            },
          },
          vacantion: {
            template: 'vacantion',
            nodeMenu: {
              vacantionLinkUser: {
                text: this.localStorage.translations.pages['setting-structure_company'].buttons
                  .employee_role_link,
                icon: employeLinkIcon,
                onClick: function (nodeId) {
                  var nodeData = chart.get(nodeId)
                  // var employeeName = nodeData["parent_id"];
                  refs.employeeRolesLink.openModalCreate_parentId(nodeData['stpid'])
                },
              },
              vacantionDelete: {
                text: this.localStorage.translations.pages['setting-structure_company'].buttons
                  .delete_vacantion,
                icon: deleteIcon,
                onClick: this.onVacantionDelete,
              },
            },
          },
        },
      })
      function exportPDF() {
        let date = new Date().toLocaleDateString('fi')

        chart.exportPDF({
          // landscape: true, //false
          // format: 'A4', //fit
          filename:
            thiss.localStorage.translations.pages.setting.pages['structure_company'] +
            ' ' +
            date +
            // (date.getDay() >= 10
            //     ? date.getDay()
            //     : '0' + date.getDay()) +
            // '.' +
            // (date.getMonth() >= 10 ? date.getMonth()
            //     : '0' + date.getMonth()) +
            // '.' +
            // date.getFullYear() +
            '.pdf',
          // nodeId: 5,
          // openInNewTab: false,
          // expandChildren: true,
          // margin: [10, 20, 10, 20],
          // padding: 10,
          // header: 'My header',
          // footer: 'Page {current-page} of {total-pages}',
          // scale: 'fit' //100
        })
      }
      chart.on('drop', function (sender, draggedNodeId, droppedNodeId) {
        var draggedNode = sender.getNode(draggedNodeId)
        var droppedNode = sender.getNode(droppedNodeId)

        if (droppedNode.tags.indexOf('group') != -1 && draggedNode.tags.indexOf('group') == -1) {
          var draggedNodeData = sender.get(draggedNode.id)
          draggedNodeData.pid = null
          draggedNodeData.stpid = droppedNode.id
          sender.updateNode(draggedNodeData)
          return false
        }
      })
      chart.nodeMenuUI.on('show', function (sender, args) {
        let itemTags = sender.obj.getNode(args.firstNodeId).tags
        if (itemTags.find((i) => i === 'role')) {
          args.menu = {
            editRole: {
              text: thiss.localStorage.translations.pages.common.buttons['redaktirovat'],
              icon: editIcon,
              onClick: refs.addAndlinkWorkRoleModal.openModalEditRole,
            },
            addRole: {
              text: thiss.localStorage.translations.pages['setting-structure_company'].buttons
                .create_role,
              icon: createRoleIcon,
              onClick: refs.addAndlinkWorkRoleModal.openModalAddRole,
            },
            addGroup: {
              text: thiss.localStorage.translations.pages['setting-structure_company'].buttons
                .create_group,
              icon: createRoleGroupIcon,
              onClick: refs.addAndlinkWorkRoleModal.openModalAddGroup,
            },
            linkRole: {
              text: thiss.localStorage.translations.pages['setting-structure_company'].buttons
                .link_role,
              icon: linkRoleIcon,
              onClick: refs.addAndlinkWorkRoleModal.openModalLinkRole,
            },
            linkGroup: {
              text: thiss.localStorage.translations.pages['setting-structure_company'].buttons
                .link_group,
              icon: linkRoleGroupIcon,
              onClick: refs.addAndlinkWorkRoleModal.openModalLinkGroup,
            },
          }
          if (itemTags.find((i) => i === 'vacancies_active')) {
            args.menu.employeeRolesLinkAdd = {
              text: thiss.localStorage.translations.pages['setting-structure_company'].buttons
                .employee_role_link,
              icon: employeLinkIcon,
              onClick: refs.employeeRolesLink.openModalCreate_parentId,
            }
          }
          if (itemTags.find((i) => i === 'parent_on')) {
            args.menu.unlinkRole = {
              text: thiss.localStorage.translations.pages['setting-structure_company'].buttons
                .unlink_role,
              icon: unlinkIcon,
              onClick: thiss.onUnlinkRoleOrGroup,
            }
          }
          args.menu.deleteRole = {
            text: thiss.localStorage.translations.pages['setting-structure_company'].buttons
              .delete_role,
            icon: deleteRoleIcon,
            onClick: thiss.onDeleteRoleOrGroup,
          }
        }
      })
      // chart.on('add', function(sender, node) {
      //     console.log('sender', sender)
      //     console.log('node', node)
      //     // your code goes here
      //     // return false; to cancel the operation
      // })

      // chart.on('click', function(sender, args) {
      //     if (args.node.tags.indexOf('group') != -1) {
      //         if (args.node.min) {
      //             sender.maximize(args.node.id)
      //         } else {
      //             sender.minimize(args.node.id)
      //         }
      //     }
      //     return false
      // })
    },
  },
}

var employeLinkIcon =
  '<svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<path d="M15.25 17.25C15.25 16.1837 14.6395 15.2578 13.75 14.8018V16.25C13.75 17.4907 12.7406 18.5 11.5 18.5H8.5C7.25935 18.5 6.25 17.4907 6.25 16.25V14.8018C5.36055 15.2578 4.75 16.1837 4.75 17.25C4.75 18.7664 5.98365 20 7.5 20H12.5C14.0163 20 15.25 18.7664 15.25 17.25Z" fill="#277FAF"/>' +
  '<path d="M3.25 17.25C3.25 16.8358 2.9142 16.5 2.5 16.5H1.5C1.0858 16.5 0.75 16.8358 0.75 17.25C0.75 17.6642 1.0858 18 1.5 18H2.5C2.9142 18 3.25 17.6642 3.25 17.25Z" fill="#277FAF"/>' +
  '<path d="M18.5 16.5H17.5C17.0858 16.5 16.75 16.8358 16.75 17.25C16.75 17.6642 17.0858 18 17.5 18H18.5C18.9142 18 19.25 17.6642 19.25 17.25C19.25 16.8358 18.9142 16.5 18.5 16.5Z" fill="#277FAF"/>' +
  '<path d="M9.25 22.25V23.25C9.25 23.6642 9.5858 24 10 24C10.4142 24 10.75 23.6642 10.75 23.25V22.25C10.75 21.8358 10.4142 21.5 10 21.5C9.5858 21.5 9.25 21.8358 9.25 22.25Z" fill="#277FAF"/>' +
  '<path d="M12.25 2.25C12.25 1.00935 11.2407 0 10 0C8.7593 0 7.75 1.00935 7.75 2.25C7.75 3.49065 8.7593 4.5 10 4.5C11.2407 4.5 12.25 3.49065 12.25 2.25Z" fill="#277FAF"/>' +
  '<path d="M6.25 9.75V12.25C6.25 12.6642 6.5858 13 7 13H7.75V14.5V16.25C7.75 16.6642 8.0858 17 8.5 17H11.5C11.9142 17 12.25 16.6642 12.25 16.25V14.5V13H13C13.4142 13 13.75 12.6642 13.75 12.25V9.75C13.75 7.68225 12.0677 6 10 6C7.93225 6 6.25 7.68225 6.25 9.75Z" fill="#277FAF"/>' +
  '</svg>'

var createRoleIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<g clip-path="url(#clip0)">' +
  '<path d="M15.5001 6.50012C14.9788 6.50012 14.5557 6.05212 14.5557 5.50012V4.00012H10.7779V5.50012C10.7779 6.05212 10.3548 6.50012 9.83348 6.50012C9.31215 6.50012 8.88904 6.05212 8.88904 5.50012V4.00012C8.88904 2.89712 9.7362 2.00012 10.7779 2.00012H14.5557C15.5974 2.00012 16.4446 2.89712 16.4446 4.00012V5.50012C16.4446 6.05212 16.0215 6.50012 15.5001 6.50012Z" fill="#277FAF"/>' +
  '<path d="M13.3373 15.38C13.1673 15.45 12.9217 15.5 12.6667 15.5C12.4117 15.5 12.1662 15.45 11.9395 15.36L1.33337 11.62V19.25C1.33337 20.77 2.49504 22 3.9306 22H21.4028C22.8384 22 24 20.77 24 19.25V11.62L13.3373 15.38Z" fill="#277FAF"/>' +
  '<path d="M8.49061 17.0535L8.50743 17.4171C8.73918 17.139 9.04196 17 9.41576 17C10.0568 17 10.3802 17.3449 10.3858 18.0348V19.9465H9.86712V18.0321C9.86525 17.8235 9.81478 17.6693 9.71573 17.5695C9.61854 17.4697 9.46622 17.4198 9.25876 17.4198C9.09055 17.4198 8.9429 17.4626 8.81581 17.5481C8.68872 17.6337 8.58966 17.746 8.51864 17.885V19.9465H8V17.0535H8.49061Z" fill="#FEFEFE"/>' +
  '<path d="M12.4267 20C12.0155 20 11.681 19.8717 11.423 19.615C11.1651 19.3565 11.0362 19.0116 11.0362 18.5802V18.4893C11.0362 18.2023 11.0932 17.9465 11.2072 17.7219C11.3231 17.4955 11.4838 17.3191 11.6894 17.1925C11.8968 17.0642 12.1211 17 12.3622 17C12.7566 17 13.0631 17.1239 13.2817 17.3717C13.5004 17.6194 13.6098 17.9742 13.6098 18.4358V18.6417H11.5548C11.5623 18.9269 11.6492 19.1578 11.8155 19.3342C11.9837 19.5089 12.1968 19.5963 12.4547 19.5963C12.6379 19.5963 12.793 19.5606 12.9201 19.4893C13.0472 19.418 13.1584 19.3235 13.2537 19.2059L13.5705 19.4412C13.3163 19.8137 12.9351 20 12.4267 20ZM12.3622 17.4064C12.1529 17.4064 11.9772 17.4795 11.8352 17.6257C11.6931 17.7701 11.6053 17.9733 11.5716 18.2353H13.0911V18.1979C13.0762 17.9465 13.0051 17.7522 12.878 17.615C12.751 17.4759 12.579 17.4064 12.3622 17.4064Z" fill="#FEFEFE"/>' +
  '<path d="M16.8982 19.2647L17.4814 17.0535H18L17.1169 19.9465H16.6964L15.9591 17.754L15.2414 19.9465H14.8209L13.9406 17.0535H14.4564L15.0535 19.2193L15.76 17.0535H16.1777L16.8982 19.2647Z" fill="#FEFEFE"/>' +
  '</g>' +
  '<path fill-rule="evenodd" clip-rule="evenodd" d="M4.20801 11.0547C6.40205 10.3546 8.00003 8.19841 8.00003 5.64706C8.00003 5.42828 7.98828 5.21242 7.96541 5.00012H21.4028C22.8383 5.00012 24 6.23012 24 7.75012V10.0401L12.8933 13.9601C12.8178 13.9901 12.7422 14.0001 12.6667 14.0001C12.5911 14.0001 12.5155 13.9901 12.44 13.9601L4.20801 11.0547Z" fill="#277FAF"/>' +
  '<path d="M3.16366 5.08764H5.33333V6.01993H3.16366V8.47055H2.16967V6.01993H0V5.08764H2.16967V2.82349H3.16366V5.08764Z" fill="#277FAF"/>' +
  '<defs>' +
  '<clipPath id="clip0">' +
  '<rect width="22.6667" height="24" fill="white" transform="translate(1.33337)"/>' +
  '</clipPath>' +
  '</defs>' +
  '</svg>'

var createRoleGroupIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<g clip-path="url(#clip0)">' +
  '<path d="M1.5 16.5H9V24H1.5V16.5Z" fill="#277FAF"/>' +
  '<path d="M16.5 16.5H24V24H16.5V16.5Z" fill="#277FAF"/>' +
  '<path d="M14.55 14.1L13.5 15H16.5V12.3L15.6 13.05C15.6 13.05 14.7 12.3 14.25 11.55C13.8 10.8 13.5 9.9 13.5 9H18V0H7.5V9H12C12 9.9 11.7 10.8 11.25 11.55C10.8 12.3 9.9 13.05 9.9 13.05L9 12.3V15H12L10.95 14.1C10.95 14.1 11.85 13.35 12.45 12.3C12.6 12.15 12.6 12 12.75 11.85C12.9 12 12.9 12.15 13.05 12.3C13.65 13.35 14.55 14.1 14.55 14.1Z" fill="#277FAF"/>' +
  '<path d="M18.2453 19.0357L18.2537 19.2781C18.3696 19.0927 18.521 19 18.7079 19C19.0284 19 19.1901 19.2299 19.1929 19.6898V20.9643H18.9336V19.6881C18.9326 19.549 18.9074 19.4462 18.8579 19.3797C18.8093 19.3131 18.7331 19.2799 18.6294 19.2799C18.5453 19.2799 18.4715 19.3084 18.4079 19.3654C18.3444 19.4225 18.2948 19.4973 18.2593 19.59V20.9643H18V19.0357H18.2453Z" fill="#FEFEFE"/>' +
  '<path d="M20.2133 21C20.0078 21 19.8405 20.9144 19.7115 20.7433C19.5826 20.571 19.5181 20.3411 19.5181 20.0535V19.9929C19.5181 19.8015 19.5466 19.631 19.6036 19.4813C19.6615 19.3304 19.7419 19.2127 19.8447 19.1283C19.9484 19.0428 20.0606 19 20.1811 19C20.3783 19 20.5315 19.0826 20.6409 19.2478C20.7502 19.413 20.8049 19.6494 20.8049 19.9572V20.0945H19.7774C19.7811 20.2846 19.8246 20.4385 19.9078 20.5561C19.9919 20.6726 20.0984 20.7308 20.2274 20.7308C20.3189 20.7308 20.3965 20.7071 20.4601 20.6595C20.5236 20.612 20.5792 20.549 20.6269 20.4706L20.7853 20.6275C20.6582 20.8758 20.4675 21 20.2133 21ZM20.1811 19.2709C20.0764 19.2709 19.9886 19.3197 19.9176 19.4171C19.8466 19.5134 19.8026 19.6488 19.7858 19.8235H20.5456V19.7986C20.5381 19.631 20.5026 19.5015 20.439 19.41C20.3755 19.3173 20.2895 19.2709 20.1811 19.2709Z" fill="#FEFEFE"/>' +
  '<path d="M22.4491 20.5098L22.7407 19.0357H23L22.5585 20.9643H22.3482L21.9795 19.5027L21.6207 20.9643H21.4104L20.9703 19.0357H21.2282L21.5268 20.4795L21.88 19.0357H22.0889L22.4491 20.5098Z" fill="#FEFEFE"/>' +
  '</g>' +
  '<defs>' +
  '<clipPath id="clip0">' +
  '<rect width="24" height="24" fill="white"/>' +
  '</clipPath>' +
  '</defs>' +
  '</svg>'

var linkRoleIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<g clip-path="url(#clip0)">' +
  '<path d="M15.5001 6.50012C14.9788 6.50012 14.5557 6.05212 14.5557 5.50012V4.00012H10.7779V5.50012C10.7779 6.05212 10.3548 6.50012 9.83348 6.50012C9.31215 6.50012 8.88904 6.05212 8.88904 5.50012V4.00012C8.88904 2.89712 9.7362 2.00012 10.7779 2.00012H14.5557C15.5974 2.00012 16.4446 2.89712 16.4446 4.00012V5.50012C16.4446 6.05212 16.0215 6.50012 15.5001 6.50012Z" fill="#277FAF"/>' +
  '<path d="M13.3373 15.38C13.1673 15.45 12.9217 15.5 12.6667 15.5C12.4117 15.5 12.1662 15.45 11.9395 15.36L1.33337 11.62V19.25C1.33337 20.77 2.49504 22 3.9306 22H21.4028C22.8384 22 24 20.77 24 19.25V11.62L13.3373 15.38Z" fill="#277FAF"/>' +
  '</g>' +
  '<path fill-rule="evenodd" clip-rule="evenodd" d="M4.20801 11.0547C6.40205 10.3546 8.00003 8.19841 8.00003 5.64706C8.00003 5.42828 7.98828 5.21242 7.96541 5.00012H21.4028C22.8383 5.00012 24 6.23012 24 7.75012V10.0401L12.8933 13.9601C12.8178 13.9901 12.7422 14.0001 12.6667 14.0001C12.5911 14.0001 12.5155 13.9901 12.44 13.9601L4.20801 11.0547Z" fill="#277FAF"/>' +
  '<path d="M3.16366 5.08764H5.33333V6.01993H3.16366V8.47055H2.16967V6.01993H0V5.08764H2.16967V2.82349H3.16366V5.08764Z" fill="#277FAF"/>' +
  '<defs>' +
  '<clipPath id="clip0">' +
  '<rect width="22.6667" height="24" fill="white" transform="translate(1.33337)"/>' +
  '</clipPath>' +
  '</defs>' +
  '</svg>'

var linkRoleGroupIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<g clip-path="url(#clip0)">' +
  '<path d="M1.5 16.5H9V24H1.5V16.5Z" fill="#277FAF"/>' +
  '<path d="M16.5 16.5H24V24H16.5V16.5Z" fill="#277FAF"/>' +
  '<path d="M14.55 14.1L13.5 15H16.5V12.3L15.6 13.05C15.6 13.05 14.7 12.3 14.25 11.55C13.8 10.8 13.5 9.9 13.5 9H18V0H7.5V9H12C12 9.9 11.7 10.8 11.25 11.55C10.8 12.3 9.9 13.05 9.9 13.05L9 12.3V15H12L10.95 14.1C10.95 14.1 11.85 13.35 12.45 12.3C12.6 12.15 12.6 12 12.75 11.85C12.9 12 12.9 12.15 13.05 12.3C13.65 13.35 14.55 14.1 14.55 14.1Z" fill="#277FAF"/>' +
  '<path d="M20.7796 20.2028H22V20.6981H20.7796V22H20.2204V20.6981H19V20.2028H20.2204V19H20.7796V20.2028Z" fill="#FEFEFE"/>' +
  '</g>' +
  '<defs>' +
  '<clipPath id="clip0">' +
  '<rect width="24" height="24" fill="white"/>' +
  '</clipPath>' +
  '</defs>' +
  '</svg>'

var deleteRoleIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<g clip-path="url(#clip0)">' +
  '<path d="M15.5001 6.50012C14.9788 6.50012 14.5557 6.05212 14.5557 5.50012V4.00012H10.7779V5.50012C10.7779 6.05212 10.3548 6.50012 9.83348 6.50012C9.31215 6.50012 8.88904 6.05212 8.88904 5.50012V4.00012C8.88904 2.89712 9.7362 2.00012 10.7779 2.00012H14.5557C15.5974 2.00012 16.4446 2.89712 16.4446 4.00012V5.50012C16.4446 6.05212 16.0215 6.50012 15.5001 6.50012Z" fill="#277FAF"/>' +
  '<path d="M13.3373 15.38C13.1673 15.45 12.9217 15.5 12.6667 15.5C12.4117 15.5 12.1662 15.45 11.9395 15.36L1.33337 11.62V19.25C1.33337 20.77 2.49504 22 3.9306 22H21.4028C22.8384 22 24 20.77 24 19.25V11.62L13.3373 15.38Z" fill="#277FAF"/>' +
  '</g>' +
  '<path fill-rule="evenodd" clip-rule="evenodd" d="M4.20801 11.0547C6.40205 10.3546 8.00003 8.19841 8.00003 5.64706C8.00003 5.42828 7.98828 5.21242 7.96541 5.00012H21.4028C22.8383 5.00012 24 6.23012 24 7.75012V10.0401L12.8933 13.9601C12.8178 13.9901 12.7422 14.0001 12.6667 14.0001C12.5911 14.0001 12.5155 13.9901 12.44 13.9601L4.20801 11.0547Z" fill="#277FAF"/>' +
  '<path d="M3.16366 5.08765H5.33333V6.01994H3.16366H2.16967H0V5.08765H2.16967H3.16366Z" fill="#277FAF"/>' +
  '<defs>' +
  '<clipPath id="clip0">' +
  '<rect width="22.6667" height="24" fill="white" transform="translate(1.33337)"/>' +
  '</clipPath>' +
  '</defs>' +
  '</svg>'

var deleteRoleGroupIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<g clip-path="url(#clip0)">' +
  '<path d="M1.5 16.5H9V24H1.5V16.5Z" fill="#277FAF"/>' +
  '<path d="M16.5 16.5H24V24H16.5V16.5Z" fill="#277FAF"/>' +
  '<path d="M20.9659 20H23V21H20.9659H20.0341H18V20H20.0341H20.9659Z" fill="#FEFEFE"/>' +
  '<path d="M14.55 14.1L13.5 15H16.5V12.3L15.6 13.05C15.6 13.05 14.7 12.3 14.25 11.55C13.8 10.8 13.5 9.9 13.5 9H18V0H7.5V9H12C12 9.9 11.7 10.8 11.25 11.55C10.8 12.3 9.9 13.05 9.9 13.05L9 12.3V15H12L10.95 14.1C10.95 14.1 11.85 13.35 12.45 12.3C12.6 12.15 12.6 12 12.75 11.85C12.9 12 12.9 12.15 13.05 12.3C13.65 13.35 14.55 14.1 14.55 14.1Z" fill="#277FAF"/>' +
  '</g>' +
  '<defs>' +
  '<clipPath id="clip0">' +
  '<rect width="24" height="24" fill="white"/>' +
  '</clipPath>' +
  '</defs>' +
  '</svg>'

var unlinkIcon =
  '<svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<path d="M23.4726 2.93918C22.7457 1.64233 21.3672 0.837158 19.8753 0.837158C19.1732 0.837158 18.4778 1.01908 17.8657 1.36308L10.1241 5.70865L11.0147 7.29591L18.7567 2.95034C19.099 2.75852 19.4859 2.65708 19.8765 2.65708C20.7102 2.65708 21.4799 3.10628 21.8858 3.82981C22.1856 4.36441 22.259 4.98436 22.0924 5.57585C21.9266 6.16733 21.5405 6.65906 21.0059 6.95891L13.9883 10.8969C13.8546 10.0418 13.4558 9.2532 12.8316 8.62868C11.7311 7.52939 9.98671 7.14042 8.52159 7.66635L7.88804 7.89445L8.50348 9.60629L9.13952 9.37941C9.95789 9.08158 10.9318 9.30349 11.5451 9.91563C11.899 10.2699 12.123 10.7187 12.194 11.2051C12.1643 11.1981 12.1346 11.1906 12.1061 11.1824C11.5134 11.0157 11.0225 10.6293 10.7223 10.0926L10.3915 9.50809L8.80298 10.4007L9.13586 10.9852C9.67376 11.945 10.5532 12.638 11.6141 12.9358C11.6507 12.9453 11.6879 12.9556 11.725 12.9643C11.669 13.0352 11.6091 13.1029 11.5456 13.1664L5.74441 18.968C5.31049 19.4015 4.73301 19.6399 4.11879 19.6399C3.50416 19.6399 2.92668 19.4015 2.49357 18.968C2.06046 18.5345 1.82206 17.9578 1.82206 17.3428C1.82206 16.7282 2.06046 16.1511 2.49357 15.718L7.53211 10.68L6.24476 9.3926L1.20667 14.4307C0.428594 15.2094 0 16.2435 0 17.3427C0 18.4429 0.428594 19.4765 1.20652 20.2553C1.9849 21.0337 3.01858 21.4614 4.11869 21.4614C5.21879 21.4614 6.25247 21.0337 7.03085 20.2553L12.8333 14.4541C13.2582 14.0276 13.5849 13.512 13.7895 12.9465C14.1256 12.857 14.4453 12.7283 14.7423 12.5608L21.8969 8.54612C22.8547 8.00781 23.5468 7.12799 23.8442 6.06833C24.142 5.00821 24.01 3.89654 23.4726 2.93918Z" fill="#277FAF"/>' +
  '</svg>'

var editIcon =
  '<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z" fill="#277FAF"/>' +
  '</svg>'

var deleteIcon =
  '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<path fill-rule="evenodd" clip-rule="evenodd" d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#277FAF"/>' +
  '</svg>'
</script>

<style lang="scss" scoped>
.tree:deep() {
  border: 1px solid #bedbeb;
  width: 100%;
  min-height: 700px;
  height: 100%;
  background: #ffffff;
  .boc-search {
    left: 20px;
    max-width: 320px;
  }
  .role_with_vacancies > {
    // rect {
    //     fill: #277faf;
    // }
    // text {
    //     fill: #ffffff;
    // }
    g {
      line {
        stroke: #ffffff;
      }
    }
  }
  .chart-menu > {
    div {
      display: grid;
      grid-template-columns: 30px auto;
      align-items: center;
      transition: 0.3s;
      svg {
        justify-self: center;
        transition: 0.3s;
      }
      &:hover {
        background: #16558f !important;
        svg {
          filter: brightness(0) invert(1);
        }
        color: #ffffff !important;
      }
    }
  }
}
</style>
